// extracted by mini-css-extract-plugin
module.exports = {"bg":"CallToActionSection__bg___1Xnc0"};